import { Alert } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSurveyStore } from '@/store';
import { useUniversityContext ,useAppContext } from '@/context';
import { Flex, LoadingSpin, PageContainer } from '@/components';
import SurveysList from './SurveysList';

export function SurveysPage() {
  const { university } = useUniversityContext();
  const { mode } = useAppContext();
  const loading = useSurveyStore(state => state.loading);
  const fetchSurveys = useSurveyStore(state => state.fetchSurveys);
  const surveys = useSurveyStore(state => state.surveys);

  const [t] = useTranslation(['common', 'survey']);

  console.log('mode', mode);
  
  useEffect(() => {
    if (!university?.samad?.Survey) return;
    fetchSurveys();
  }, [fetchSurveys, university]);

  if (!university?.samad?.Survey) {
    return <>{t('common:errors.module-not-activated')}</>;
  }

  if (loading) {
    return <LoadingSpin fillHeight />;
  }

  if (surveys.length === 0) {
    return (
      <PageContainer title={t('common:labels.cultural')}>
        <Flex className="min-h-[80px]" justify="center">
          <Alert className="px-4 lg:px-8" type="warning" message={t('survey:messages.no-survey-to-participate')} />
        </Flex>
      </PageContainer>
    );
  }

  return (
    <PageContainer title={t('common:labels.cultural')}>
      <Flex direction="column" className="max-w-xl mx-auto">
        <SurveysList
          surveys={surveys}
          onIgnore={() => { }}
          showIgnore={false}
          extraSpace
        />
      </Flex>
    </PageContainer>
  );

}

export default SurveysPage;
